const NON_SUBMIT_ELEMENTS = ["TEXTAREA", "BUTTON", "A", "SELECT"];
const INTERACTIVE_SELECTOR =
  '.fixed, [role="dialog"], [role="combobox"], [role="listbox"], [role="option"]';

export function shouldSubmitBookingOnEnter(event: KeyboardEvent): boolean {
  const target = event.target as HTMLElement | null;

  if (
    event.key !== "Enter" ||
    event.defaultPrevented ||
    event.isComposing ||
    event.repeat ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey ||
    !target
  ) {
    return false;
  }

  if (target.isContentEditable || NON_SUBMIT_ELEMENTS.includes(target.tagName)) {
    return false;
  }

  return !target.closest(INTERACTIVE_SELECTOR);
}
